import { FC } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { FaTrash } from "react-icons/fa";
import { Navigate } from "react-router-dom";
import { useRouteParams } from "app/route/route";
import { removeReportUserRoute, reportUsersRoute } from "app/route/Routes";
import { useRemoveUserFromReportMutation } from "app/api/graph/types";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { reportGraphId, userGraphId } from "app/api/graph/helpers";

export const RemoveReportUserScreen: FC = () => {
    const { reportId, userId } = useRouteParams(removeReportUserRoute);
    const [removeUser, { data, loading, error }] = useRemoveUserFromReportMutation({
        variables: {
            reportId: reportGraphId(reportId),
            userId: userGraphId(userId),
        },
    });

    if (data?.removeUserFromReport) {
        return <Navigate to={reportUsersRoute.build({ reportId })} />;
    }

    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={removeReportUserRoute} />
                <h1>Remove user from report?</h1>
                {error ? <Alert variant="danger">{error.message}</Alert> : null}
                <p>Are you sure that you want to remove this user from this report?</p>
                <Button variant="danger" disabled={loading} onClick={() => removeUser()}>
                    <FaTrash /> Delete
                </Button>
            </Container>
        </NavigationScreen>
    );
};
